<div class="fullcontainer">
    <div class='sheet'>
        <h1 class='title'>Shredder Import</h1>

        <input type='file' (change)="fileChanged($event)"/>
        <button class='btn btn-secondary' (click)='this.run()'>Run!</button>
    </div>
</div>

